var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaler"},[_c('p',[_vm._t("default")],2),_c('button',{staticClass:"button ",on:{"click":_vm.subtract}},[_vm._v("−")]),_c('button',{staticClass:"button last",on:{"click":_vm.add}},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }